import { render, staticRenderFns } from "./shanxiTrainingSupervisionFour.vue?vue&type=template&id=08835479"
import script from "./shanxiTrainingSupervisionFour.vue?vue&type=script&lang=js"
export * from "./shanxiTrainingSupervisionFour.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports